import { Modal } from "@design-system/Modal";
import { Text } from "@design-system/Typography/Text";
import { type FC } from "react";
import { useKnowledgeBaseDeleteModalTranslations } from "./i18n";

export const DeleteCustomItemModal: FC<{
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onDelete: () => void;
}> = ({ open, onOpenChange, onDelete }) => {
    const { t, keys } = useKnowledgeBaseDeleteModalTranslations();

    return (
        <Modal open={open} onOpenChange={onOpenChange}>
            <Modal.Overlay centerContent>
                <Modal.Content>
                    <Modal.Header>
                        <Modal.Title>
                            {t(keys.delete_custom_item_modal_title)}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Text variant="body" color="primary">
                            {t(keys.delete_custom_item_modal_body)}
                        </Text>
                    </Modal.Body>
                    <Modal.Footer>
                        <Modal.CancelCTA>
                            {t(keys.delete_custom_item_modal_cancel_button)}
                        </Modal.CancelCTA>
                        <Modal.ConfirmCTA
                            variant="flatDanger"
                            onClick={onDelete}
                        >
                            {t(keys.delete_custom_item_modal_confirm_button)}
                        </Modal.ConfirmCTA>
                    </Modal.Footer>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};
